
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["h-100 d-inline-block m-auto",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 6.6l72 39.3-72 42.8zm45.5 12.5l11.7-1.8-1.5 11.6z","fill":"#ffcc05"}}),_c('path',{attrs:{"d":"M36.3 86.4l5-6.1 1.9 6zm42.5-36.3H33.7L55 93.4z","fill":"#010001"}}),_c('path',{attrs:{"d":"M31.5 46.4h6.3l1.1 2.8c.1.1.2.3.3.4.1.1.3.2.4.3.1 0 .2.1.3.1h.9c1.6 0 3.1.5 4.2 1.5 1.2.9 2 2.2 2.3 3.8l1.9 9.5H20l1.9-9.5c.3-1.5 1.1-2.8 2.3-3.8 1.2-.9 2.6-1.5 4.2-1.5h.9c.1 0 .2 0 .3-.1.2-.1.3-.2.4-.3.1-.1.2-.2.3-.4l1.1-2.8h.1z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}}),_c('path',{attrs:{"d":"M34.6 47.7c-5.2 0-7-9.2-7.2-10.7 0-4 3.2-7.2 7.2-7.2s7.2 3.2 7.2 7.2c-.1 2.3-2 10.7-7.2 10.7z","fill":"#fff"}}),_c('path',{attrs:{"d":"M27.1 31.6c.1-1 .7-2.4 2.6-1.7 1.6-1 2.4-4.3 11.4-4.5.7 0 1.2.4 1.4 1 .3 1 .4 1.7-.4 3.1.3 0 .6.2.9.5.7.8.9 1.9.7 2.9-.5 1.7-1.1 4.9-2.7 7.6.3-1.9-.2-3.5-.5-4.4-.5-1.6-2.4-1.8-2.8-1.7-1.3.3-2.2.5-2.8.6-.6 0-1.6-.1-2.8-.4-1.3-.3-2.6.4-3 1.6-.7 1.2-.8 4.3-.9 4.4-.2.1-1.6-3.3-1.1-9z","fill":"#fff"}})])
          )
        }
      }
    